import React, { useState, useEffect } from 'react';

import { UniformJson } from '@/types/users';

interface CircularUniformProps {
  uniformJsonString: string | undefined;
  propsSize?: 'small' | 'default'; // Optional prop for size preset
}

const CircularUniform: React.FC<CircularUniformProps> = ({ uniformJsonString, propsSize = 'default' }) => {
  const [uniformJson, setUniformJson] = useState<UniformJson | undefined>(undefined);
  const sizeClassName = propsSize === 'small' ? 'w-6 h-6' : 'w-10 h-10';

  useEffect(() => {
    setUniformJson(uniformJsonString ? (JSON.parse(uniformJsonString) as UniformJson) : undefined);
  }, [uniformJsonString]);

  return (
    <>
      <div className="relative w-fit">
        {uniformJson && (
          <>
            {uniformJson.uniformType === 1 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon1">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M26,93.874127 L26,6.12587302 C30.8935762,3.44330744 36.2848264,1.55561694 42,0.636557997 L42,99.363442 C36.2848264,98.4443831 30.8935762,96.5566926 25.9999987,93.8741196 Z M10,80.0048745 C3.72089484,71.6474342 0,61.2582479 0,50 C0,38.7417521 3.72089484,28.3525658 10,19.9951255 L10,80.0048745 Z M74,6.12587964 L74,93.874127 C69.1064238,96.5566926 63.7151736,98.4443831 58,99.363442 L58,0.636557997 C63.7151731,1.55561686 69.1064228,3.4433071 74,6.12587964 Z M90,19.9951255 C96.2791052,28.3525658 100,38.7417521 100,50 C100,61.2582479 96.2791052,71.6474342 90,80.0048745 L90,19.9951255 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 2 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon2">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M87.5641341,17 L50,17 L50,0 C64.9685404,0 78.4008097,6.57755799 87.5641341,17 Z M87.5641341,83 C78.4008097,93.422442 64.9685404,100 50,100 L50,83 L87.5641341,83 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 3 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon3">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M38,98.5507072 C29.3203826,96.4126064 21.532856,92.0077705 15.3012208,86 L38,86 L38,62 L14,62 L14,84.6987792 C7.99222948,78.467144 3.58739357,70.6796174 1.4492928,62 L14,62 L14,38 L1.4492928,38 C3.58739357,29.3203826 7.99222948,21.532856 14,15.3012208 L14,38 L38,38 L38,14 L15.3012208,14 C21.532856,7.99222948 29.3203826,3.58739357 38,1.4492928 L38,14 L62,14 L62,1.4492928 C70.6796174,3.58739357 78.467144,7.99222948 84.6987792,14 L62,14 L62,38 L86,38 L86,15.3012208 C92.0077705,21.532856 96.4126064,29.3203826 98.5507072,38 L86,38 L86,62 L98.5507072,62 C96.4126064,70.6796174 92.0077705,78.467144 86,84.6987792 L86,62 L62,62 L62,86 L84.6987792,86 C78.467144,92.0077705 70.6796174,96.4126064 62,98.5507072 L62,86 L38,86 L38,98.5507072 Z M38,38 L38,62 L62,62 L62,38 L38,38 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 4 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon4">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M5.087585,72.1781908 C1.82947827,65.522958 0,58.0375283 0,50.1237436 C0,22.4411644 22.3857625,0 50,0 C77.6142375,0 100,22.4411644 100,50.1237436 C100,58.0375283 98.1705217,65.522958 94.912415,72.1781908 L85,72.1781908 L85,85.9192783 C82.0085312,88.8591261 78.6501173,91.4251177 75.0000052,93.5418198 L75,72.1781908 L65,72.1781908 L65,97.9528108 C61.7938031,98.9623112 58.4484362,99.6567711 55,100 L55,72.1781908 L45,72.1781908 L45,100 C41.5515638,99.6567711 38.2061969,98.9623112 35,97.9528108 L35,72.1781908 L25,72.1781908 L25,93.5418227 C21.3498827,91.4251177 17.9914688,88.8591261 15,85.9192783 L15,72.1781908 L5.087585,72.1781908 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 5 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon5">
                    <g
                      id="Group"
                      transform="translate(50.000000, 50.000000) rotate(-30.000000) translate(-50.000000, -50.000000) ">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M50,0 L50,100 C22.3857625,100 0,77.6142375 0,50 C0,22.3857625 22.3857625,0 50,0 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 6 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon6">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M5,71.750886 L5,69.9257538 L4.16043685,69.9257538 C2.77321,66.7428724 1.70618539,63.3876498 1.00018116,59.9010051 L5,59.9010051 L5,49.8762564 L0,49.8762564 C0,46.4431224 0.344302594,43.0906036 1.00018116,39.8515077 L5,39.8515077 L5,29.826759 L4.16043685,29.826759 C4.42843835,29.2118509 4.70839084,28.6033751 5,28.0016268 L5,29.826759 L15,29.826759 L15,19.8020102 L9.99633813,19.8020102 C11.5192183,17.7695381 13.1926372,15.8568966 15,14.0807217 L15,19.8020102 L25,19.8020102 L25,9.77726152 L19.9951255,9.77726152 C21.5919488,8.57456834 23.2629436,7.46549694 25,6.45817725 L25,9.77726152 L35,9.77726152 L35,2.04718923 C38.2061969,1.03768878 41.5515638,0.343228942 45,5.04735143e-14 L45,9.77726152 L55,9.77726152 L55,-4.16056078e-14 C58.4484362,0.343228942 61.7938031,1.03768878 65,2.04718923 L65,9.77726152 L75,9.77726152 L75,6.45817725 C76.7370564,7.46549694 78.4080512,8.57456834 80.0048745,9.77726152 L75,9.77726152 L75,19.8020102 L85,19.8020102 L85,14.0807217 C86.8073628,15.8568966 88.4807817,17.7695381 90.0036619,19.8020102 L85,19.8020102 L85,29.826759 L95,29.826759 L95,28.0016268 C95.2916092,28.6033751 95.5715616,29.2118509 95.8395631,29.826759 L95,29.826759 L95,39.8515077 L98.9998188,39.8515077 C99.6556974,43.0906036 100,46.4431224 100,49.8762564 L95,49.8762564 L95,59.9010051 L98.9998188,59.9010051 C98.2938146,63.3876498 97.22679,66.7428724 95.8395631,69.9257538 L95,69.9257538 L95,71.750886 C93.5943972,74.6514095 91.917964,77.3956294 90.0036619,79.9505026 L85,79.9505026 L85,85.6717911 C83.4321435,87.2125926 81.7634906,88.6506993 80.0048745,89.9752513 L75,89.9752513 L75,93.2943355 C71.8658488,95.1118311 68.516637,96.5980782 65,97.7053236 L65,89.9752513 L55,89.9752513 L55,99.7525128 C53.3554688,99.9161959 51.687497,100 50,100 C48.312503,100 46.6445312,99.9161959 45,99.7525128 L45,89.9752513 L35,89.9752513 L35,97.7053236 C31.483363,96.5980782 28.1341512,95.1118311 25,93.2943355 L25,89.9752513 L19.9951255,89.9752513 C18.2365094,88.6506993 16.5678565,87.2125926 15,85.6717911 L15,79.9505026 L9.99633813,79.9505026 C8.08203603,77.3956294 6.40560283,74.6514095 5,71.750886 Z M15,69.9257538 L15,79.9505026 L25,79.9505026 L25,69.9257538 L15,69.9257538 Z M15,49.8762564 L15,59.9010051 L25,59.9010051 L25,49.8762564 L15,49.8762564 Z M15,29.826759 L15,39.8515077 L25,39.8515077 L25,29.826759 L15,29.826759 Z M35,9.77726152 L35,19.8020102 L45,19.8020102 L45,9.77726152 L35,9.77726152 Z M55,9.77726152 L55,19.8020102 L65,19.8020102 L65,9.77726152 L55,9.77726152 Z M25,19.8020102 L25,29.826759 L35,29.826759 L35,19.8020102 L25,19.8020102 Z M35,29.826759 L35,39.8515077 L45,39.8515077 L45,29.826759 L35,29.826759 Z M75,29.826759 L75,39.8515077 L85,39.8515077 L85,29.826759 L75,29.826759 Z M65,19.8020102 L65,29.826759 L75,29.826759 L75,19.8020102 L65,19.8020102 Z M55,29.826759 L55,39.8515077 L65,39.8515077 L65,29.826759 L55,29.826759 Z M45,19.8020102 L45,29.826759 L55,29.826759 L55,19.8020102 L45,19.8020102 Z M5,39.8515077 L5,49.8762564 L15,49.8762564 L15,39.8515077 L5,39.8515077 Z M25,39.8515077 L25,49.8762564 L35,49.8762564 L35,39.8515077 L25,39.8515077 Z M35,49.8762564 L35,59.9010051 L45,59.9010051 L45,49.8762564 L35,49.8762564 Z M75,49.8762564 L75,59.9010051 L85,59.9010051 L85,49.8762564 L75,49.8762564 Z M85,39.8515077 L85,49.8762564 L95,49.8762564 L95,39.8515077 L85,39.8515077 Z M65,39.8515077 L65,49.8762564 L75,49.8762564 L75,39.8515077 L65,39.8515077 Z M55,49.8762564 L55,59.9010051 L65,59.9010051 L65,49.8762564 L55,49.8762564 Z M45,39.8515077 L45,49.8762564 L55,49.8762564 L55,39.8515077 L45,39.8515077 Z M5,59.9010051 L5,69.9257538 L15,69.9257538 L15,59.9010051 L5,59.9010051 Z M25,59.9010051 L25,69.9257538 L35,69.9257538 L35,59.9010051 L25,59.9010051 Z M35,69.9257538 L35,79.9505026 L45,79.9505026 L45,69.9257538 L35,69.9257538 Z M75,69.9257538 L75,79.9505026 L85,79.9505026 L85,69.9257538 L75,69.9257538 Z M85,59.9010051 L85,69.9257538 L95,69.9257538 L95,59.9010051 L85,59.9010051 Z M65,59.9010051 L65,69.9257538 L75,69.9257538 L75,59.9010051 L65,59.9010051 Z M55,69.9257538 L55,79.9505026 L65,79.9505026 L65,69.9257538 L55,69.9257538 Z M45,59.9010051 L45,69.9257538 L55,69.9257538 L55,59.9010051 L45,59.9010051 Z M25,79.9505026 L25,89.9752513 L35,89.9752513 L35,79.9505026 L25,79.9505026 Z M65,79.9505026 L65,89.9752513 L75,89.9752513 L75,79.9505026 L65,79.9505026 Z M45,79.9505026 L45,89.9752513 L55,89.9752513 L55,79.9505026 L45,79.9505026 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 7 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon7">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorB} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M25.0000139,93.3108902 L25.0000139,6.68910976 C32.3543332,2.43486022 40.8928207,0 50,0 C59.1071793,0 67.6456668,2.43486022 75,6.68911782 L74.9999861,93.3108902 C67.6456668,97.5651398 59.1071793,100 50,100 C40.8928207,100 32.3543332,97.5651398 25,93.3108822 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorA}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 8 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon8">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M84,86.6609056 C78.3804713,91.8749928 71.5601588,95.8128493 64,98.0135379 L64,1.98646214 C71.5601588,4.18715074 78.3804713,8.12500724 84,13.3390944 L84,86.6609056 Z M88,82.4975801 L88,17.5024199 C95.4813382,26.2422329 100,37.5934214 100,50 C100,62.4065786 95.4813382,73.7577671 88,82.4975801 Z M16,86.6609056 L16,13.3390944 C21.6195287,8.12500724 28.4398412,4.18715074 36,1.98646214 L36,98.0135379 C28.4398412,95.8128493 21.6195287,91.8749928 16,86.6609056 Z M12,82.4975801 C4.51866184,73.7577671 0,62.4065786 0,50 C0,37.5934214 4.51866184,26.2422329 12,17.5024199 L12,82.4975801 Z M60,98.9998188 C56.7689006,99.6556974 53.4246584,100 50,100 C46.5753416,100 43.2310994,99.6556974 40,98.9998188 L40,1.00018116 C43.2310994,0.344302594 46.5753416,0 50,0 C53.4246584,0 56.7689006,0.344302594 60,1.00018116 L60,98.9998188 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 9 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon9">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorA} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M10,80.0048745 L10,19.9951255 C19.1222879,7.85343099 33.6440104,0 50,0 C66.3559896,0 80.8777121,7.85343099 90,19.9951255 L90,80.0048745 C80.8777121,92.146569 66.3559896,100 50,100 C33.6440104,100 19.1222879,92.146569 10,80.0048745 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorB}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}

            {uniformJson.uniformType === 10 && (
              <svg className={sizeClassName} viewBox="0 0 100 100" version="1.1">
                <g id="uniforoms-&amp;-aicons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="uniform-aicon10">
                    <g id="Group">
                      <circle id="Oval" fill={uniformJson.uniformColorB} cx="50" cy="50" r="50"></circle>
                      <path
                        d="M28.4498591,95 C25.4516227,93.5296899 22.6225765,91.7648693 20,89.7430071 L69.2537795,4 C72.3386716,5.28912109 75.2663858,6.88184914 78,8.74107481 L28.4498591,95 Z"
                        id="Combined-Shape"
                        fill={uniformJson.uniformColorA}></path>
                    </g>
                  </g>
                </g>
              </svg>
            )}
          </>
        )}
        <div className={`absolute top-0 ${sizeClassName} flex justify-center items-center`}>
          <svg className={`${sizeClassName} font-footballlog`} viewBox="0 0 32 32">
            <text
              x="50%"
              y="55%"
              fontSize="22"
              fontWeight="700"
              fill={uniformJson?.printColor}
              textAnchor="middle"
              dominantBaseline="middle"
              stroke="#333"
              strokeWidth="1"
              strokeLinejoin="round">
              {uniformJson?.printNumber}
            </text>
          </svg>
        </div>
      </div>
    </>
  );
};

export default CircularUniform;
